<template>
  <div>
    <div class="mask" v-show="msg.show"></div>
    <div class="loading" v-show="msg.show">
      <van-loading type="spinner" color="#FFF" />
    </div>
  </div>
</template>
<script>
import { reactive, ref } from "@vue/reactivity";
// 别人要去操作你的状态的
export const useLoadingEffect = () => {
  const msg = reactive({
    show: false,
  });
  return { msg };
};
export default {
  name: "myloading",
  // 必须要传参数的
  props: {
    msg: Object,
  },
  setup(props, context) {},
};
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 3000;
}
.loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 0.1rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 0.25rem 0.3rem;
  border-radius: 0.05rem;
  font-size: 0.2rem;
  // color: #fff;
  z-index: 3001;
}
</style>